import _ from 'underscore';

export const formatInteger = ({ i18n, value, options }) => i18n.formatDecimal(value, {
  minimumFractionDigits: 0, maximumFractionDigits: 1, compact: 'short', withSign: 'always', ...options,
});

export const parseDecimal = ({ i18n, value }) => (_.isString(value) ? i18n.parseDecimal(value) : value);

export const formatCurrency = ({
  i18n, value, currencyCode, options,
}) =>
  i18n.formatCurrency(value, currencyCode, options);

export const formatDate = ({ i18n, dateString }) => i18n.formatDate(new Date(dateString));

export const formatCivilDate = ({ i18n, civilDate, options }) => i18n.formatCivilDate(civilDate, options);
